import { css } from "styled-components";

export const disabledStyle = css`
  opacity: ${(p) => (p.theme.isDarkMode ? 0.3 : 0.4)};
`;
